<template>
  <div class="brain-modal-input-group">
    <label for="" class="brain-modal-input-group__label">{{ name }}:</label>
    <span v-if="textLoading" class="loader"></span>
    <input v-else :value="value" type="text" class="w-full form-control form-input form-input-bordered" @input="onInput" />
    <div class="dropdown">
      <button :id="'smartText_' + name" class="smart-text" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="tox-icon tox-tbtn__icon-wrap"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="wand-magic-sparkles" class="svg-inline--fa fa-wand-magic-sparkles " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" color="#0FBC92"><path fill="currentColor" d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"></path></svg></span>
      </button>
      <div class="dropdown-menu" :aria-labelledby="'smartText_' + name">
        <a href="#" class="dropdown-item px-4 py-2 text-nowrap hover:bg-gray" @click="smartText('fix', value)">Fix Spelling & Grammar</a>
        <a href="#" class="dropdown-item px-4 py-2 text-nowrap hover:bg-gray" @click="smartText('rephrase', value)">Rephrase Text</a>
        <a href="#" class="dropdown-item px-4 py-2 text-nowrap hover:bg-gray" @click="smartText('friendly', value)">Make it Friendly</a>
        <a href="#" class="dropdown-item px-4 py-2 text-nowrap hover:bg-gray" @click="smartText('formal', value)">Make it Formal</a>
      </div>
    </div>
  </div>
</template>

<script>
import SharedStepEditorInputField from "../form/SharedStepEditorInputField.vue";
import swal from "sweetalert2";

export default {
  components: {SharedStepEditorInputField},
  props: {
    name: String,
    value: String,
  },
  data() {
    return {
      textLoading: false,
      disabled: false,
    }
  },
  model: {
    prop: 'value',
    event: 'update',
  },
  methods: {
    onInput(event) {
      this.$emit('update', event.target.value);
    },
    smartText(action, text) {
      this.textLoading = true;
      axios.post(`/api/?entity=smart-text&action=${action}SmartText`, { text })
          .then((result) => {
            if (result.status === 200 && result.data.text) {
              this.$emit('update', result.data.text);
            } else {
              swal.fire({
                title: 'UhOh!',
                text: 'Something went wrong.',
                type: 'error',
                confirmButtonText: 'Ok',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-lg btn-primary',
              });
            }
            this.textLoading = false;
          });
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../sass/web/_variables.scss';

.brain-modal-input-group {
  display: grid;
  grid-template-columns: 3fr 8fr 1fr;
  grid-template-rows: 1fr;
  padding: 5px 0;
  &__label {
    color: #43454b;
    align-self: center;
    justify-self: left;
  }
  button.smart-text {
    background: white;
    width: 100%;
    height: 100%;
    padding: 12px;
  }
}
.loader {
  width: 26px;
  height: 26px;
  border: 2px solid #66CCCC;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: auto;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.dropdown-item {
  display: block;
}

.dropdown-item:hover {
  background-color: #eee;
}
</style>
